import * as fs from "fs/promises";
import path from "path";
import { useEffect, useMemo, useState } from "react";
/**
 * Validates tools by checking if their executables exist on disk.
 * Returns a set of valid tool IDs.
 */
const validateTools = async (starters, discoveryPath) => {
    if (discoveryPath === undefined) {
        return new Set();
    }
    const validIds = new Set();
    for (const starter of starters) {
        if (!starter?.exePath) {
            continue;
        }
        const exePath = path.isAbsolute(starter.exePath)
            ? starter.exePath
            : path.join(discoveryPath, starter.exePath);
        try {
            await fs.stat(exePath);
            validIds.add(starter.id);
        }
        catch {
            // File doesn't exist, tool is not valid
        }
    }
    return validIds;
};
/**
 * Hook to validate tools by checking if executables exist on disk.
 * Returns a function to check if a specific tool is valid.
 */
export const useToolsValidation = (starters, discoveryPath, deploymentCounter = 0) => {
    const [validToolIds, setValidToolIds] = useState(() => new Set());
    useEffect(() => {
        let cancelled = false;
        void validateTools(starters, discoveryPath).then((validIds) => {
            if (!cancelled) {
                setValidToolIds(validIds);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [starters, discoveryPath, deploymentCounter]);
    const isToolValid = useMemo(() => {
        return (info) => {
            return validToolIds.has(info?.id);
        };
    }, [validToolIds]);
    return { isToolValid };
};
